// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"353":"contact","594":"about"}[chunkId] + "." + {"353":"a68c7b89","594":"4a54b064"}[chunkId] + ".js";
};